import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export enum EPanelSide {
  Left,
  Right,
}

interface INewbuildingHeaderPanel {
  side: EPanelSide;
}

export const NewbuildingHeaderPanel: React.FC<React.PropsWithChildren<INewbuildingHeaderPanel>> = ({
  side,
  children,
}) => {
  return (
    <div
      className={classNames({
        [styles['left']]: side === 0,
        [styles['right']]: side === 1,
      })}
    >
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
